import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "@store/store";

const initialState: { value: number } = {
    value: 0,
};

export const LoaderSlice = createSlice({
    name: "loader",
    initialState,
    reducers: {
        showLoader: (state) => {
            state.value += 1;
        },
        hideLoader: (state) => {
            state.value -= 1;
        },
    },
});

export const { showLoader, hideLoader } = LoaderSlice.actions;

export const getLoaderCount = (state: RootState) => state.loaderCount;

export default LoaderSlice.reducer;
